export let USER_ROLES = /*#__PURE__*/function (USER_ROLES) {
  USER_ROLES["SUPER_ADMIN"] = "SuperAdmin";
  USER_ROLES["ADMIN"] = "Admin";
  USER_ROLES["COMPANY_SUPERVISOR"] = "CompanySupervisor";
  USER_ROLES["ENTERPRISE_ADMIN"] = "EnterpriseAdmin";
  USER_ROLES["USER"] = "user";
  USER_ROLES["SENDOSO_SUPERVISOR"] = "SendosoSupervisor";
  USER_ROLES["WAREHOUSE_MANAGER"] = "WarehouseManager";
  USER_ROLES["OPS_TEAM"] = "OpsTeam";
  USER_ROLES["CS_ASSOCIATE"] = "CsAssociate";
  USER_ROLES["POSTAL_SUPERVISOR"] = "PostalSupervisor";
  USER_ROLES["CUSTOM_INK_PRO_ADMIN"] = "CustomInkProAdmin";
  USER_ROLES["WAREHOUSE_VIEWER"] = "WarehouseViewer";
  return USER_ROLES;
}({});

// will be removed then new role management will be merged
export let TEMPORARY_ALLOWED_USER_ROLES = /*#__PURE__*/function (TEMPORARY_ALLOWED_USER_ROLES) {
  TEMPORARY_ALLOWED_USER_ROLES["COMPANY_SUPERVISOR"] = "CompanySupervisor";
  TEMPORARY_ALLOWED_USER_ROLES["USER"] = "user";
  TEMPORARY_ALLOWED_USER_ROLES["SENDOSO_SUPERVISOR"] = "SendosoSupervisor";
  TEMPORARY_ALLOWED_USER_ROLES["POSTAL_SUPERVISOR"] = "PostalSupervisor";
  return TEMPORARY_ALLOWED_USER_ROLES;
}({});
export const SUPERVISOR_ROLES = Object.values(TEMPORARY_ALLOWED_USER_ROLES).filter(role => role !== TEMPORARY_ALLOWED_USER_ROLES.USER);
export let OTHER_USER_ROLES = /*#__PURE__*/function (OTHER_USER_ROLES) {
  OTHER_USER_ROLES["ADMIN"] = "admin";
  OTHER_USER_ROLES["EMPLOYEE"] = "employee";
  OTHER_USER_ROLES["OTHERS"] = "others";
  return OTHER_USER_ROLES;
}({});